/** Joins class names, skipping falsy values: `cn('a', active && 'b')`. */
export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}
